<template>
  <div
    class="col d-flex flex-column"
    style="flex: auto; overflow-y:auto;"
    data-cy="convenio-container"
  >
    <div class="d-flex flex-row" data-cy="convenio-header-row">
      <back-button data-cy="convenio-back-button"></back-button>
      <div class="d-flex flex-column mb-4" data-cy="convenio-header-info">
        <h4 class="text-primary font-weight-bold" data-cy="convenio-title">
          Convênio
        </h4>
        <small class="font-weight-bold" data-cy="convenio-subtitle"
          >Selecione um convênio para o seu atendimento</small
        >
      </div>
    </div>

    <search-filter
      placeholder="Buscar convênio..."
      data-cy="convenio-search-filter"
    ></search-filter>

    <div
      class="d-flex flex-column"
      style="color: orange;"
      data-cy="convenio-error-list"
    >
      <ul v-for="error in errors" :key="error" data-cy="convenio-error-item">
        <li>{{ error }}</li>
      </ul>
    </div>

    <loading-overlay
      v-if="isLoading"
      message="Carregando convênios..."
      data-cy="convenio-loading-overlay"
    />

    <div
      v-else
      class="text-primary text-uppercase py-3"
      style="overflow-y:auto;"
      data-cy="convenio-list-wrapper"
    >
      <div
        :class="
          `custom-radio-wrapper mb-2 ${
            helthPlan && helthPlan.id === convenio.id ? 'border-primary' : ''
          }`
        "
        v-for="convenio in convenios"
        :key="convenio.id"
        :data-cy="`convenio-item-${convenio.id}`"
      >
        <div
          class="custom-control custom-radio"
          data-cy="convenio-radio-wrapper"
        >
          <input
            type="radio"
            :id="'convenio-' + convenio.id"
            name="convenio"
            class="custom-control-input"
            :value="convenio"
            :checked="helthPlan && helthPlan.id === convenio.id"
            @click="
              submit(convenio);
              advance();
            "
            :data-cy="`convenio-radio-${convenio.id}`"
          />
          <label
            class="custom-control-label"
            :for="'convenio-' + convenio.id"
            :data-cy="`convenio-label-${convenio.id}`"
            >{{ convenio.nome }}</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from "@/components/back-button.vue";
import SearchFilter from "@/components/filter.vue";
import LoadingOverlay from "@/components/loading-overlay.vue";
import { generateTo } from "@/core/routerHelper.js";
import { mapGetters } from "vuex";

export default {
  name: "convenio",
  components: { SearchFilter, BackButton, LoadingOverlay },
  data() {
    return {
      errors: []
    };
  },

  methods: {
    advance() {
      if (this.helthPlan && this.helthPlan.id) {
        this.submit(this.helthPlan);
      }
    },
    checkForm() {
      this.errors = [];
      if (this.helthPlan == null) {
        this.errors.push("Selecione um convênio para prosseguir");
      } else {
        return true;
      }
    },
    submit(convenio) {
      convenio.stepId = 1;
      this.$store.dispatch("load_selected", convenio);

      this.$store.dispatch("set_to", {
        name: generateTo(2, this.$route),
        params: { organizationId: this.$route.params.organizationId },
        query: {
          convenio: this.helthPlan.id,
          ...(this.clinicSpecific
            ? { clinica: this.$route.query.clinica, c: null }
            : {})
        }
      });

      this.$router.push(this.$store.getters.to);
    }
  },
  computed: {
    ...mapGetters("loading", ["isLoading"]),

    convenios() {
      return this.$store.getters.get_healthPlans;
    },
    helthPlan() {
      return this.$store.getters.get_selected[0];
    },
    clinicSpecific() {
      return this.$store.getters.clinicSpecific;
    },
    isBackNav() {
      return this.$store.state.Config.goBack;
    }
  },
  async mounted() {
    let payload = {
      params: {
        organizationId: this.$route.params.organizationId
      },
      url: `${this.$serverHost}agendamentos/convenios`
    };

    await this.$store.dispatch("load_healthplan", payload);

    if (this.convenios.length === 1 && !this.isBackNav) {
      this.submit(this.convenios[0]);
    }

    this.$store.dispatch("setGoBack", false);
    this.$store.dispatch("set_actual", this.$route.fullPath);
    this.$store.dispatch("set_from", {
      name: "index",
      params: { organizationId: this.$route.params.organizationId },
      query: {
        ...(this.clinicSpecific
          ? { clinica: this.$route.query.clinica, c: null }
          : {})
      }
    });

    if (this.helthPlan.nome) {
      if (this.$store.getters.clinicSpecific) {
        this.$store.dispatch("set_to", {
          name: generateTo(2, this.$route),
          params: { organizationId: this.$route.params.organizationId },
          query: {
            convenio: this.helthPlan.id,
            ...(this.clinicSpecific
              ? { clinica: this.$route.query.clinica, c: null }
              : {})
          }
        });
      } else {
        this.$store.dispatch("set_to", {
          name: generateTo(2, this.$route),
          params: { organizationId: this.$route.params.organizationId },
          query: { convenio: this.helthPlan.id }
        });
      }
    } else {
      this.$store.dispatch("set_to", "");
    }
  }
};
</script>
